<template>
  <floating-window name="Video">
    <div>
    </div>
    <el-tabs>

      <el-tab-pane label="video">
          <video-controller />
      </el-tab-pane>

      <el-tab-pane label="youtube">
        <youtube-controller />
      </el-tab-pane>

      <el-tab-pane label="stream">
        <stream-controller />
      </el-tab-pane>

    </el-tabs>
  </floating-window>
</template>

<script>
import VideoController   from './video-file-controller'
import YoutubeController from './youtube-controller'
import StreamController  from './stream-controller'

export default {
  name: 'VideoControlPanel',
  data () {
    return {}
  },
  components: {
    VideoController,
    YoutubeController,
    StreamController
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/video/controller/index.vue